<template>
    <div class="order-state-badge" :class="[{ 'order-state-badge--compact': compact }]">
        <span class="order-state-badge__label">
            <slot>New Order</slot>
        </span>
    </div>
</template>

<script>
export default {
    name: 'OrderStatusBadge',
    props: {
        compact: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" src="./OrderStatusBadge.scss"></style>
